export default __webpack_public_path__ + "static/media/user.7b979caf.svg";